import AppSearchAPIConnector from "@elastic/search-ui-app-search-connector";

const searchKey = import.meta.env.VITE_ELASTIC_SEARCH_KEY;
const engineName = import.meta.env.VITE_ELASTIC_SNOMEDCT_ENGINE_NAME;
const endpointBase = import.meta.env.VITE_ELASTIC_ENDPOINT_BASE;

export const connector = new AppSearchAPIConnector({
  searchKey: searchKey as string,
  engineName: engineName as string,
  endpointBase: endpointBase as string
});
